import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

const meta = {
	description: 'With the 2021 NRL and AFL season beginning on March 11 and March 18 respectively, there is much to be excited about.',
	image: '/images/blog-footysback/footysback.png',
	title: 'Footys Back | blueshyft',
	url: 'https://blueshyft.com.au/blogs/footysback',
};

import '../../css/about.css';

export default class About extends Component {
	render () {

		return (
			<React.Fragment>
				<Helmet
					title={meta.title}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.image },
					]}
				/>

				<section className="about-cryptocurrency">
					<div className="about-cryptocurrency-sub">
						<div className="about-cryptocurrency-image-container">
							<img src="/images/blog-footysback/footysback.png" alt="crpyotcurrency" className="about-cryptocurrency-image" />
						</div>
					</div>
				</section>

				<section className="wrapup">
					<div className="block block-crypto">
						<p>With the 2021 NRL and AFL season beginning on March 11 and March 18 respectively, there is much to be excited about. Reigning champions, Melbourne Storm, are hot favourites again this year, but not without the youthful Penrith Panthers and gutsy South Sydney Rabbitohs hot on their trail. The 2021 season is set to be an exciting one, particularly with Magic Round being held in Brisbane over the weekend of May 14 to May 16. Another bonus for NRL fans is the return to near full capacity in stadiums around the nation, which many fans will be inevitably looking forward to.</p>
					</div>

					<div className="block block-crypto">
						<p>With regards to the AFL, Richmond and Geelong start as heavy favourites.  Some see the Eagles as a possibility.  With  rule changes being introduced this season to increase scoring, the early rounds should provide challenges for players and umpires - especially around marks. In addition, the re-introduction of twenty minute quarters will provide the opportunity to score more goals but could test player's fitness.  All in all, we're psyched for the first bounce and fans back in the stands!</p>
					</div>

					<div className="block block-crypto">
						<p>Here at blueshyft, we are extremely excited for the two codes to re-commence. If you are looking to tip your favourite NRL or AFL team, head to your closest blueshyft store and top-up your Ladbrokes or Neds account!</p>
					</div>
				</section>

			</React.Fragment>
		);
	}
};



// WEBPACK FOOTER //
// ./client/scenes/blog-20210310/index.js